import { Epic, ofType } from 'redux-observable';
import { map } from 'rxjs/operators';

import { Action } from '../../../actions';
import {
    changeMinusPhraseGroupsMassActions,
    ON_ACCEPT_MINUS_PHRASE_GROUPS_MASS_ACTIONS,
    OnAcceptMinusPhraseGroupsMassActionsAction
} from '../../../actions/groups-edit/groups-edit-mass-actions';
import { fetchLibraryListsForEdit } from '../../../actions/minusPhrasesEditor';
import { BulkReplacementRadio } from '../../../components/BulkReplacementModeChooser/BulkReplacementModeChooser';
import { EpicDeps } from '../../../service/StoreFactory';
import { State } from '../../../typings/state';

export const onAcceptMinusPhraseGroupsMassActionsEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) => {
    return action$.pipe(
        ofType(ON_ACCEPT_MINUS_PHRASE_GROUPS_MASS_ACTIONS),
        map((action: OnAcceptMinusPhraseGroupsMassActionsAction) => {
            const { minusPhrasesRadio } = store$.value.groupsEditMassActions[
                action.massActionId
            ].data;
            const {
                value,
                selectedLibraryListItems = []
            } = store$.value.minusPhraseLibraryEditor.data[
                action.massActionId
            ].minusKeywordsEditor;

            const isDataEmpty =
                value.length === 0 && selectedLibraryListItems.length === 0;

            if (
                minusPhrasesRadio === BulkReplacementRadio.REPLACE &&
                isDataEmpty
            ) {
                return changeMinusPhraseGroupsMassActions(
                    action.massActionId,
                    BulkReplacementRadio.DELETE
                );
            }

            return fetchLibraryListsForEdit(action.massActionId);
        })
    );
};
